import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
import { TweenMax } from 'gsap';
import EFVideo from '@/components/UI/EFVideo';

export default function DSection4() {
    const { useLang, useEffect, useRef } = useGlobal()
    const { t } = useLang('xboost')

    let controller: any;
    useEffect(() => {
        controller = new ScrollMagic.Controller();
    }, []);

    const fadeIn = (el: any) => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 750;
        const target = `.xboost_h5 .D_section4 ${el}`;

        const scene1 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: 0,
            triggerHook: 1,
            duration: layoutH / 10,
        });
        const tween1 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 0 });
        scene1.setTween(tween1);
        scene1.addTo(controller);

        const scene2 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: layoutH / 10,
            triggerHook: 1,
            duration: layoutH / 10,
        });
        const tween2 = TweenMax.fromTo(target, 0.5, { opacity: 0 }, { opacity: 1 });
        scene2.setTween(tween2);
        scene2.addTo(controller);

        const scene3 = new ScrollMagic.Scene({
            triggerElement: target,
            offset: (layoutH / 10) * 2,
            triggerHook: 0,
            duration: (layoutH / 10) * 8,
        });
        const tween3 = TweenMax.fromTo(target, 0.5, { opacity: 1 }, { opacity: 1 });
        scene3.setTween(tween3);
        scene3.addTo(controller);
    };

    useEffect(() => {
        fadeIn('.title');
        fadeIn('.desc');
    }, []);

    const videoRef = useRef(null)
    useEffect(() => {
        const layoutH = typeof window !== 'undefined' ? window.innerHeight : 667
        const scene = new ScrollMagic.Scene({
            triggerElement: '.D_section4',
            triggerHook: 1,
            offset: layoutH / 2,
        })
        scene.on('enter', () => {
            videoRef?.current?.play()
        })
        scene.addTo(controller)

        const video4El = document.querySelector('.D_section4 .video_fast') as HTMLElement
        new ScrollMagic.Scene({
            triggerElement: '.D_section4 .videoBox',
            triggerHook: 1,
        })
            .on('enter', () => {
                if (video4El) {
                    video4El.currentTime = 0
                }
            })
            .addTo(controller)
    }, [])

    return (
        <div className={`D_section4 ${css.D_section4}`}>
            <div className="videoBox">
                <div className="video-box-bottom">
                    <EFVideo
                        ref={videoRef}
                        sources={["/video/xboost/h5/04_BMS.webm", "/video/xboost/h5/04_BMS.mp4"]}
                        className="video_fast"
                        width={'100%'}
                        height="100%"
                        muted
                        autoPlay={false}
                        loop={false}
                        preload="auto"
                    />
                </div>
                <div className="textBox">
                    <p className="title">{t('section_4_title')}</p>
                    <p className="desc">{t('section_4_desc')}</p>
                </div>
            </div>
        </div>
    );
}
